import { Routes } from '@angular/router';
import { AppLayout } from '@/layout/components/app.layout';
import { Notfound } from '@/pages/notfound/notfound';
import { LandingLayout } from '@/layout/components/app.landinglayout';
import { AuthLayout } from '@/layout/components/app.authlayout';
import { AuthenticationGuard } from '@/core/guards/authentication.guard';
import { LoginComponent } from '@/features/login/login.component';

export const appRoutes: Routes = [
    {
        path: 'login',
        loadChildren: () => import('@/features/login/login.routes').then(m => m.LOGIN_ROUTES)
    },
    {
        path: '',
        component: AppLayout,
        children: [
            //DASHBOARD
           // HOME - Produção Diária
           {
                 path: '',
                 loadChildren: () => import('@/features/producao-diaria/producao-diaria.routes').then(m => m.PRODUCAO_DIARIA_ROUTES),
                canActivate: [AuthenticationGuard],
                data: { roles: ['P_MAX'] }
            },
            {
                path: 'producao-diaria',
                loadChildren: () => import('@/features/producao-diaria/producao-diaria.routes').then(m => m.PRODUCAO_DIARIA_ROUTES),
                canActivate: [AuthenticationGuard],

            },
            {
                path: 'dashboard-marketing',
                loadComponent: () => import('@/pages/dashboards/marketing/marketingdashboard').then((c) => c.MarketingDashboard),
                canActivate: [AuthenticationGuard],
                data: { roles: ['P_MAX'] }

            },
            {
                path: 'dashboard-penalidades',
                loadComponent: () => import('@/pages/dashboards/penalidade/penalidade-dashboard').then((c) => c.PenalidadeDashboard),
                canActivate: [AuthenticationGuard],
                data: { roles: ['P_MAX', 'WFM_PENALIDADE_CON'] },
                title: 'Home - Dashboard Penalidades',
            },
            {
                path: 'dashboard-visao-computacional',
                loadChildren: () => import('@/pages/dashboards/aquarelle/aquarelle.routes').then((c) => c.AQUARELLE_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'dashboard-leitura-dia',
                loadChildren: () => import('@/pages/dashboards/leitura-dia/leitura-dia.routes').then((c) => c.LEITURA_DIA_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'dashboard-leitura',
                loadChildren: () => import('@/features/dashboards/dashboard-leiturista/dashboard-leiturista.route').then((m) => m.DASHBOARD_LEITURISTA_ROUTES),
                canActivate: [AuthenticationGuard],
            },

            // CONFIGURAÇÃO
            {
                path: 'caracteristica-equipe',
                loadChildren: () => import('@/features/caracteristica-equipe/caracteristica-equipe.routes').then(m => m.CARACTERISTICA_EQUIPE_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'cargo',
                loadChildren: () => import('@/features/cargo/cargo.routes').then(m => m.CARGO_ROUTES),
                canActivate: [AuthenticationGuard]
            },
            {
                canActivate: [AuthenticationGuard],
                path: 'centro-de-custo',
                loadChildren: () => import('@/features/centro-de-custo/centro-de-custo.routes').then(m => m.centroDeCustoRoutes),
            },
            {
                path: 'estrutura-organizacional',
                loadChildren: () => import('@/features/hierarquia/hierarquia.routes').then(m => m.HIERARQUIA_ROUTES),
                canActivate: [AuthenticationGuard]
            },
            {
                canActivate: [AuthenticationGuard],
                path: 'feriados',
                loadChildren: () => import('@/features/feriados/feriados.routes').then(m => m.feriadosRoutes),
            },
            {
                canActivate: [AuthenticationGuard],
                path: 'localidades',
                loadChildren: () => import('@/features/localidades/localidades.routes').then(m => m.localidadesRoutes),
            },
            {
                canActivate: [AuthenticationGuard],
                path: 'medidores',
                loadChildren: () => import('@/features/medidores/medidores.routes').then(m => m.medidoresRoutes),
            },
            {
                canActivate: [AuthenticationGuard],
                path: 'caracteristica-servico',
                loadChildren: () => import('@/features/atividade-tipo/atividade-tipo.routes').then(m => m.ATIVIDADE_TIPO_ROUTES),
            },
            {
                canActivate: [AuthenticationGuard],
                path: 'classificacao-servico',
                loadChildren: () => import('@/features/classificacao-servico/classificacao-servico.routes').then(m => m.classificacaoServicoRoutes),
            },
            {
                canActivate: [AuthenticationGuard],
                path: 'fluxo-servicos',
                loadChildren: () => import('@/features/atividade-fluxo/atividade-fluxo.routes').then(m => m.ATIVIDADE_FLUXO_ROUTES),
            },
            {
                canActivate: [AuthenticationGuard],
                path: 'status-servico',
                loadChildren: () => import('@/features/atividade-status/atividade-status.routes').then(m => m.ATIVIDADE_STATUS_ROUTES),
            },
            {
                canActivate: [AuthenticationGuard],
                path: 'tabelas-de-baixa',
                loadChildren: () => import('@/features/tabelas-de-baixa/tabelas-de-baixa.routes').then(m => m.tabelasDeBaixaRoutes),
            },
            {
                path: 'checklist',
                loadChildren: () => import('@/features/checklist/checklist.routes').then(m => m.CHECKLIST_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'itens-checklist',
                loadComponent: () => import('@/features/checklist/checklist-template-layout-item/checklist-template-layout-item-list/checklist-template-layout-item-list.component').then((c) => c.ChecklistTemplateLayoutItemListComponent),

            },
            {
                canActivate: [AuthenticationGuard],
                path: 'spia',
                loadChildren: () => import('@/features/spia/spia.routes').then(m => m.SPIA_ROUTES)
            },
            {
                canActivate: [AuthenticationGuard],
                path: 'penalidade',
                loadChildren: () => import('@/features/penalidade/penalidade.routes').then(m => m.PENALIDADE_ROUTES)
            },
            {
                path: 'ajuste-ponto',
                loadChildren: () => import('@/features/ajuste-ponto/ajuste-ponto.routes').then(m => m.AJUSTE_PONTO_ROUTES),
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'empresa-spe',
                loadChildren: () => import('@/features/empresa-spe/empresa-spe.routes').then(m => m.EMPRESA_SPE_ROUTES),
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'monitor',
                loadChildren: () => import('@/features/monitor/monitor.routes').then(m => m.MONITOR_ROUTES),
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'monitor-dashboard',
                loadChildren: () => import('@/features/monitor-dashboard/monitor/monitor.routes').then(m => m.MONITOR_ROUTES),
                canActivate: [AuthenticationGuard],
                data: {
                    title: 'Monitor Dashboard',
                    roles: ['P_MAX', 'MONITOR_INTERFACE_CON'],
                },
                title: 'Sigos - Monitor Dashboard'
            },

            //EQUIPES
            {
                canActivate: [AuthenticationGuard],
                path: 'configuracao-equipe',
                loadChildren: () => import('@/features/configuracao-equipe/configuracao-equipe.routes').then(m => m.CONFIGURACAO_EQUIPE_ROUTES),
            },
            {
                path: 'configuracao-servico',
                loadChildren: () => import('@/features/configuracao-servico/configuracao-servico.routes').then(m => m.CONFIGURACAO_SERVICO_ROUTES),
                canActivate: [AuthenticationGuard]
            },
            {
                canActivate: [AuthenticationGuard],
                path: 'importacao',
                loadChildren: () => import('@/features/importacao/importacao.routes').then(m => m.IMPORTACAO_ROUTES),
            },
            {
                canActivate: [AuthenticationGuard],
                path: 'planejamento-escala',
                loadChildren: () => import('@/features/planejamento-escala/planejamento-escala.routes').then(m => m.PLANEJAMENTO_ESCALA_ROUTES),
            },
            {
                canActivate: [AuthenticationGuard],
                path: 'relacao-funcionario',
                loadChildren: () => import('@/features/funcionario/funcionario.routes').then(m => m.FUNCIONARIO_ROUTES),
            },
            {
                canActivate: [AuthenticationGuard],
                path: 'relacao-veiculos',
                loadChildren: () => import('@/features/relacao-veiculos/relacao-veiculos.routes').then(m => m.RELACAO_VEICULOS_ROUTES),
            },


            // =========================================== MONITORAMENTO ===========================================
            {
                path: 'gantt',
                loadChildren: () => import('@/features/gantt/gantt.routes').then(m => m.GANTT_ROUTES),
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'gantt-leitura',
                loadChildren: () => import('@/features/gantt-leitura/gantt-leitura.routes').then(m => m.GANTT_ROUTES),
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'monitor-integracao',
                loadChildren: () => import('@/features/monitor-integracao/monitor-integracao.routes').then(m => m.MONITOR_INTEGRACAO_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'monitoramento-carga-sicom',
                loadChildren: () => import('@/features/leitura/monitoramento-carga-sicom/monitoramento-carga-sicom.routes').then(m => m.MONITORAMENTO_CARGA_SICOM_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'producao-dia',
                loadChildren: () => import('@/features/producao-do-dia/producao-do-dia.routes').then(m => m.PRODUCAO_DO_DIA_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                canActivate: [AuthenticationGuard],
                path: 'atividade-list',
                loadChildren: () => import('@/features/atividade/atividade/atividade.routes').then(m => m.ATIVIDADE_ROUTES),

            },
            {
                path: 'toi',
                loadChildren: () => import('@/features/toi/toi.routes').then(m => m.TOI_ROUTES),
                canActivate: [AuthenticationGuard],
            },



            // GESTÃO
            {
                canActivate: [AuthenticationGuard],
                path: 'servicos-abertos',
                loadChildren: () => import('@/features/servicos-abertos/servicos-abertos.routes').then(m => m.SERVICOS_ABERTOS_ROUTES),

            },
            {
                canActivate: [AuthenticationGuard],
                path: 'servicos-encerrados',
                loadChildren: () => import('@/features/atividade/encerradas/encerradas.routes').then(m => m.ENCERRADAS_ROUTES),

            },
            {
                canActivate: [AuthenticationGuard],
                path: 'servicos-encerrados-leitura',
                loadChildren: () =>
                    import('@/features/atividade/encerradas-leitura/encerradas-leitura.routes').then(
                        (m) => m.ENCERRADAS_LEITURA_ROUTES
                    ),
            },
            {
                canActivate: [AuthenticationGuard],
                path: 'atividade-leitura',
                loadChildren: () => import('@/features/atividade/atividade-leitura/atividade-leitura.routes').then(m => m.ATIVIDADE_LEITURA_ROUTES),
            },
            {
                canActivate: [AuthenticationGuard],
                path: 'servicos-equipe',
                loadChildren: () => import('@/features/servicos-equipe/servicos-equipe.routes').then(m => m.SERVICOS_EQUIPE_ROUTES),

            },
            {
                canActivate: [AuthenticationGuard],
                path: 'visitas-servico',
                loadChildren: () => import('@/features/visitas-servico/visitas-servico.routes').then(m => m.VISITAS_SERVICO_ROUTES),

            },
            {
                path: 'demandas-equipe',
                loadChildren: () => import('@/features/demandas-equipe/demandas-equipe.routes').then(m => m.DEMANDAS_EQUIPE_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'atendimento-tipo-servico',
                loadChildren: () => import('@/features/atendimento-tipo-servico/atendimento-tipo-servico.routes').then(m => m.ATENDIMENTO_TIPO_SERVICO_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'atendimento-consolidado',
                loadChildren: () => import('@/features/atendimento-consolidado/atendimento-consolidado.routes').then(m => m.ATENDIMENTO_CONSOLIDADO_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'extensao-horario',
                loadChildren: () => import('@/features/extensao-horario/extensao-horario.routes').then(m => m.EXTENSAO_HORARIO_ROUTES),
                canActivate: [AuthenticationGuard],

            },
            {
                path: 'paralisacao-equipes',
                loadChildren: () => import('@/features/paralisacao-equipes/paralisacao-equipes.routes').then(m => m.PARALISACAO_EQUIPES_ROUTES),
                canActivate: [AuthenticationGuard],

            },
            {
                path: 'paralisacao-servico',
                loadChildren: () => import('@/features/paralisacao-servico/paralisacao-servico.routes').then(m => m.PARALISACAO_SERVICO_ROUTES),
                canActivate: [AuthenticationGuard],

            },
            {
                path: 'pendencia-servicos',
                loadChildren: () => import('@/features/pendencia-servicos/pendencia-servicos.routes').then(m => m.PENDENCIA_SERVICOS_ROUTES),
                canActivate: [AuthenticationGuard],

            },

            {
                path: 'tempo-execucao-negativo',
                loadChildren: () => import('@/features/tempo-execucao-negativo/tempo-execucao-negativo.routes').then(m => m.TEMPO_EXECUCAO_NEGATIVO_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'tempo-atendimento',
                loadChildren: () => import('@/features/tempo-atendimento/tempo-atendimento.routes').then(m => m.TEMPO_ATENDIMENTO_ROUTES),
                canActivate: [AuthenticationGuard],
            },

            {
                path: 'registros-empregados',
                loadChildren: () => import('@/features/registros-empregados/registros-empregados.routes').then(m => m.REGISTROS_EMPREGADOS_ROUTES),
                canActivate: [AuthenticationGuard],

            },
            {
                path: 'relatorio-atividades',
                loadChildren: () => import('@/features/relatorio-atividades/relatorio-atividades.routes').then(m => m.RELATORIO_ATIVIDADES_ROUTES),
                canActivate: [AuthenticationGuard],

            },
            {
                path: 'manobras',
                loadChildren: () => import('@/features/manobras/manobras.routes').then(m => m.MANOBRAS_ROUTES),
                canActivate: [AuthenticationGuard],

            },
            {
                path: 'seguranca-trabalho',
                loadChildren: () => import('@/features/seguranca-trabalho/seguranca-trabalho.routes').then(m => m.SEGURANCA_TRABALHO_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'tempo-padrao',
                loadChildren: () => import('@/features/tempo-padrao/tempo-padrao.routes').then(m => m.TEMPO_PADRAO_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'producao-mensal',
                loadChildren: () => import('@/features/producao-mensal/producao-mensal.routes').then(m => m.PRODUCAO_MENSAL_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'producao-diaria',
                loadChildren: () => import('@/features/producao-diaria/producao-diaria.routes').then(m => m.PRODUCAO_DIARIA_ROUTES),
                canActivate: [AuthenticationGuard],
            },

            {
                canActivate: [AuthenticationGuard],
                path: 'servicos-aplicados',
                loadChildren: () => import('@/features/servicos-aplicados/servicos-aplicados.routes').then(m => m.SERVICOS_APLICADOS_ROUTES),
            },




            //LICENÇAS
            {
                canActivate: [AuthenticationGuard],
                path: 'configuracao-licenca',
                loadChildren: () => import('@/features/configuracao-licenca/configuracao-licenca.routes').then(m => m.CONFIGURACAO_LICENCA_ROUTES),
            },
            {
                canActivate: [AuthenticationGuard],
                path: 'controle-licenca',
                loadChildren: () => import('@/features/controle-licenca/controle-licenca.routes').then(m => m.CONTROLE_LICENCA_ROUTES),
            },

            // MATERIAIS

            {
                path: 'deposito',
                loadChildren: () => import('@/features/materiais/deposito/deposito.routes').then(m => m.DEPOSITO_ROUTES),
                canActivate: [AuthenticationGuard],

            },

            //PROGRAMAÇÃO
            {
                canActivate: [AuthenticationGuard],
                path: 'ajuste-programacao',
                loadChildren: () => import('@/features/ajuste-programacao/ajuste-programacao.routes').then(m => m.AJUSTE_PROGRAMACAO_ROUTES)
            },
            {
                canActivate: [AuthenticationGuard],
                path: 'ajuste-programacao-leitura',
                loadChildren: () => import('@/features/ajuste-programacao-leitura/ajuste-programacao-leitura.routes').then(m => m.AJUSTE_PROGRAMACAO_LEITURA_ROUTES)
            },
            {
                canActivate: [AuthenticationGuard],
                path: 'carga-leiturista',
                loadChildren: () =>
                    import('@/features/carga-leiturista/carga-leiturista.routes').then(
                        (m) => m.CARGA_LEITURISTA_ROUTES
                    ),
            },
            //SPIA - PARAMETRIZAÇÃO




            {
                path: 'priorizacao-cenario',
                loadChildren: () => import('@/features/priorizacao-cenario/priorizacao-cenario.routes').then(m => m.PRIORIZACAO_CENARIO_ROUTES),
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'servico-pendente',
                loadChildren: () => import('@/features/servico-pendente/servico-pendente.routes').then(m => m.SERVICO_PENDENTE_ROUTES),
                canActivate: [AuthenticationGuard]
            },

            // ÍNDICES
            {
                path: 'indice-tempo',
                loadChildren: () => import('@/features/indice-tempo/indice-tempo.routes').then(m => m.INDICE_TEMPO_ROUTES),
                canActivate: [AuthenticationGuard]
            },

            {
                path: 'indices-consolidados',
                loadChildren: () => import('@/features/indices-consolidados/indices-consolidados.routes').then(m => m.INDICES_CONSOLIDADOS_ROUTES),
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'indices-atendimento',
                loadChildren: () => import('@/features/indices-atendimento/indices-atendimento.routes').then(m => m.INDICES_ATENDIMENTO_ROUTES),
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'indices-tempo-geral',
                loadChildren: () => import('@/features/indices-tempo-geral/indices-tempo-geral.routes').then(m => m.INDICES_TEMPO_GERAL_ROUTES),
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'indices-programacao',
                loadChildren: () => import('@/features/indices-programacao/indices-programacao.routes').then(m => m.INDICES_PROGRAMACAO_ROUTES),
                canActivate: [AuthenticationGuard]
            },

            // MATERIAIS
            {
                path: 'material-estoque',
                loadChildren: () => import('@/features/materiais/material-estoque/material-estoque.routes').then(m => m.MATERIAL_ESTOQUE_ROUTES),
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'materiais-aplicados',
                loadChildren: () => import('@/features/materiais/materiais-aplicados/materiais-aplicados.routes').then(m => m.MATERIAIS_APLICADOS_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'material-consulta-saldo-sap',
                loadChildren: () => import('@/features/materiais/material-consulta-saldo-sap/material-consulta-saldo-sap.routes').then(m => m.MATERIAL_CONSULTA_SALDO_SAP_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'grupo-materiais',
                loadChildren: () => import('@/features/materiais/grupo-materiais/grupo-materiais.routes').then(m => m.GRUPO_MATERIAIS_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'material',
                loadChildren: () => import('@/features/materiais/material/material.routes').then(m => m.MATERIAL_ROUTES),
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'material-operacao-spe',
                loadChildren: () => import('@/features/materiais/material-operacao-spe/material-operacao-spe.routes').then(m => m.MATERIAL_OPERACAO_SPE_ROUTES),
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'material-kit',
                loadChildren: () => import('@/features/materiais/material-kit/material-kit.routes').then(m => m.MATERIAL_KIT_ROUTES),
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'material-fluxo-sap',
                loadChildren: () => import('@/features/materiais/material-fluxo-sap/material-fluxo-sap.routes').then(m => m.MATERIAL_FLUXO_SAP_ROUTES),
                canActivate: [AuthenticationGuard]
            },

            // USUÁRIO
            {
                path: 'usuario-motivo-ausencia',
                loadChildren: () => import('@/features/controle-acesso/usuario-motivo-ausencia/usuario-motivo-ausencia.routes').then(m => m.USUARIO_MOTIVO_AUSENCIA_ROUTES),
                canActivate: [AuthenticationGuard],

            },
            {
                path: 'usuario',
                loadChildren: () => import('@/features/controle-acesso/usuario/usuario.routes').then(m => m.USUARIO_ROUTES),
                canActivate: [AuthenticationGuard],

            },
            {
                path: 'rotina',
                loadChildren: () => import('@/features/controle-acesso/rotina/rotina.routes').then(m => m.ROTINA_ROUTES),
            },
            {
                path: 'perfil',
                loadChildren: () => import('@/features/controle-acesso/perfil/perfil.routes').then(m => m.PERFIL_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'mensagens-usuario',
                loadChildren: () => import('@/features/mensagens-usuario/mensagens-usuario.routes').then(m => m.MENSAGENS_USUARIO_ROUTES),
                canActivate: [AuthenticationGuard],
            },

            // HELP / CONTROLE DE VERSÃO
            {
                path: 'controle-versao',
                loadChildren: () => import('@/features/controle-versao/controle-versao.routes').then(m => m.CONTROLE_VERSAO_ROUTES),
                canActivate: [AuthenticationGuard],

            },

            {
                path: 'help',
                loadChildren: () => import('@/features/help/help.routes').then(m => m.HELP_ROUTES),
                canActivate: [AuthenticationGuard],
            },















            ///====================demo=====================
            {
                path: 'uikit',
                data: { breadcrumb: 'UI Kit' },
                loadChildren: () => import('@/pages/uikit/uikit.routes')
            },
            {
                path: 'documentation',
                data: { breadcrumb: 'Documentation' },
                loadComponent: () => import('@/pages/documentation/documentation').then((c) => c.Documentation)
            },
            {
                path: 'pages',
                loadChildren: () => import('@/pages/pages.routes'),
                data: { breadcrumb: 'Pages' }
            },
            {
                path: 'apps',
                loadChildren: () => import('@/apps/apps.routes'),
                data: { breadcrumb: 'Apps' }
            },

            {
                path: 'blocks',
                data: { breadcrumb: 'Free Blocks' },
                loadChildren: () => import('@/pages/blocks/blocks.routes')
            },
            {
                path: 'ecommerce',
                loadChildren: () => import('@/pages/ecommerce/ecommerce.routes'),
                data: { breadcrumb: 'E-Commerce' }
            },
            {
                path: 'profile',
                loadChildren: () => import('@/pages/usermanagement/usermanagement.routes')
            }
        ]
    },

    { path: 'notfound', component: Notfound },
    {
        path: 'auth',
        component: AuthLayout,
        children: [
            {
                path: 'login',
                loadComponent: () => import('@/pages/auth/login').then((c) => c.Login)
            },
            {
                path: 'register',
                loadComponent: () => import('@/pages/auth/register').then((c) => c.Register)
            },
            {
                path: 'verification',
                loadComponent: () => import('@/pages/auth/verification').then((c) => c.Verification)
            },
            {
                path: 'forgot-password',
                loadComponent: () => import('@/pages/auth/forgotpassword').then((c) => c.ForgotPassword)
            },
            {
                path: 'new-password',
                loadComponent: () => import('@/pages/auth/newpassword').then((c) => c.NewPassword)
            },
            {
                path: 'lock-screen',
                loadComponent: () => import('@/pages/auth/lockscreen').then((c) => c.LockScreen)
            },
            {
                path: 'access',
                loadComponent: () => import('@/pages/auth/access').then((c) => c.Access)
            },
            {
                path: 'oops',
                loadComponent: () => import('@/pages/oops/oops').then((c) => c.Oops)
            },
            {
                path: 'error',
                loadComponent: () => import('@/pages/notfound/notfound').then((c) => c.Notfound)
            },
            {
                path: 'manutencao',
                loadComponent: () => import('@/pages/manutencao/manutencao.component').then((c) => c.ManutencaoComponent)
            }
        ]
    },
    { path: '**', redirectTo: '/notfound' }
];
